<!--
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2024-09-03 08:20:25
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-09-22 11:43:36
-->
<template>
<div class="index page_map hascontrol">
	<div class="top_wrap">
		<div class="index_top">
			<!-- <page-search placeholder="项目搜索" :readonly="true" class="page-search" fieldClass="search_field" :righticon="this.publicPath + 'statics/images/search_ico.png'" :searchlefticon="this.publicPath + 'statics/images/search_map.png'"></page-search> -->
			<div class="PageSearch page-search">
				<van-row type="flex" justify="space-start">
					<van-col v-if="searchlefticon" class="left_col">
						<van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" @click="clicksearchleft" />
					</van-col>
					<van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
						<van-cell-group  class="search_field">
							<van-field v-model="search_value" :readonly="readonly" :placeholder="placeholder" @focus="showFullScreenSearchPage">
								<van-icon slot="right-icon" :name="righticon" />
							</van-field>
						</van-cell-group>
					</van-col>
					<van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
						<van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
					</van-col>
				</van-row>
			</div>
		</div>
		<!-- 当前页筛选 -->
		<div class="search" v-if="search_status">
			<div class="search_bg"></div>
			<div class="search_t" @click="areaPicker= true">
				
				<div class="search_nr">
					<div class="search_t_l"></div>
					<div class="search_t_m">
						<van-field v-model="selectArea" placeholder="请选择省市区" :readonly="true"/>
					</div>
					<div class="search_t_r"></div>
				</div>
			</div>
			<div class="search_fenlei">
				<ul class="search_list clearfix">
					<li :class="item.status == 1 ? 'search_item f-l active': 'search_item f-l'" v-for="item in cateList" :key="item.id" :data-id="item.id" @click="selectCate(item)">{{item.name}}</li>
					<!-- <li class="search_item f-l">民间文学</li>
					<li class="search_item active f-l">民间文学</li>
					<li class="search_item f-l">民间文学</li>
					<li class="search_item f-l">民间文学</li> -->
				</ul>
			</div>
			<div class="search_actions">
				<div class="search_action" @click="reset">重置</div>
				<div class="search_action" @click="submit">确定</div>
			</div>
		</div>
	</div>
    <!-- 地图区域 -->
    <div class="mapwrap">
        <!-- 地图容器 -->
        <div id="container"></div>
        <!-- 全国 | 周边 -->
        <div class="range">
			<!-- <span class="item" @click.stop="goQuanguo(1)">全球</span> -->
            <span class="item" @click.stop="goQuanguo(0)">全国</span>
            <span class="item active">周边</span>
        </div>
        <!-- 非遗介绍 -->
    </div>
    <!-- 左侧 分类 -->
    <div class="fenlei">
        <ul class="list">
			<!-- :class="
            item.id == 1
              ? 'item item1'
              : item.id == 2
              ? 'item item2'
              : item.id == 3
              ? 'item item3'
              : item.id == 4
              ? 'item item4'
              : 'item'
          " -->
		  <!-- <span class="">{{ item.name.slice(0,2) }}</span> -->
            <li v-for="(item, index) in typeList" :key="index"  :data-typeId="item.id" @click="selectedFun(item, index)" ref="item">
				<!-- <span v-if="type_id.indexOf(item.id)==-1" class="item" :style="'color:'+(item.font_color)+';border: 0.0134rem solid' +(item.font_color)">{{ item.name }}</span>
				<span v-else class="item" :style="'background-image:url('+(imageUrl + item.thumb) +');background-size:100% 100%'">{{ item.name }}</span> -->
				<span v-if="type_id.indexOf(item.id)==-1" class="item" :style="'background-image:url('+(imageUrl + item.typeicon1) +');background-size:100% 100%'"></span>
				<span v-else class="item" :style="'background-image:url('+(imageUrl + item.typeicon) +');background-size:100% 100%'"></span>
			</li>
        </ul>
    </div>
	 <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @confirm="confrimArea" @cancel="areaPicker=false"/>
    </van-popup>
	<!-- 遮罩层 -->
	<van-overlay :show="search_status" class="overlay"/>
	<div id="mapBtn" @click="clickButtonDom"></div>
</div>
</template>

<script>
import router from "../../../../.././router";
import areaList from "./../area.js";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
// import {
//     Geolocation
// } from 'vue-amap'; // 使用vue-amap插件，要引用
export default {
    name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
			searchlefticon: '', // 搜索栏左侧图标
			searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan_white.png', // 搜索栏右侧图标
			search_value: '', // 搜索值
			readonly: true, // 搜索栏只读
			placeholder: '项目搜索',
			righticon: process.env.BASE_URL + 'statics/images/search_ico.png',
            typeList: [], // 项目列表
            publicPath: process.env.BASE_URL,
            lng: "", // 经度
			lat: "", // 纬度
			// lng: "117.108568", // 默认定位天津, 定位失败时取默认定位
			// lat: "38.664049", 
            center: [115.665993, 37.735097],
            markerGroups: [
                // {
                //   id: 1,
                //   position: [115.658449, 37.689046],
                //   icon: process.env.BASE_URL + "statics/images/icon_maptip.png",
                //   content: "衡水植物园"
                // },
                // {
                //   id: 2,
                //   position: [115.653292, 37.649961],
                //   icon: process.env.BASE_URL + "statics/images/icon_maptip.png",
                //   content: "衡水动物园"
                // }
			],
			type_id: [], // 数组 非遗0 、乡村1、民宿2、景区3、农特产品4,默认传全部
			mapIcons: {
				icon0: process.env.BASE_URL + "statics/images/maptip_0.png",
				icon1: process.env.BASE_URL + "statics/images/maptip_1.png",
				icon2: process.env.BASE_URL + "statics/images/maptip_2.png",
				icon3: process.env.BASE_URL + "statics/images/maptip_3.png",
				icon4: process.env.BASE_URL + "statics/images/maptip_4.png",
			},
			selectArea: null, // 搜索 地区
			areaPicker: false, // 地区弹层
			areaList: areaList, // 地区弹层数据 全国省市区
			area_name: null, // 地区数组名称[省，市，县]
			cateList: null , // 分类数组
			search_status: false , // 筛选层是否展开
			// lngNew: null , // 查询地址后的新坐标
			// latNew: null, // 查询地址后的新坐标
			adress: '',  // 用于逆解析的地址
			positionAdress: { // 当前用户定位的地址
				province: '',
				city: '',
				district: ''
			},
			map: null,
			showInfo: false, // 信息窗体 
			infoTitle: '1111111111',
			infoContent: null,
			infoId: null,
			infoLng: null,
			infoLat: null,
			myAdress: null, // 用户的当前位置地址,如 河北省-衡水市-桃城区
			myAdressArr: null, // 用户的当前位置地址数组,如[河北省,衡水市,桃城区]
			myAdressText: null, // 用户的当前位置地址,如 河北省衡水市桃城区
			myAdressTextDetail: null, // 用户的当前位置详细地址,如 河北省衡水市桃城区逸升佳苑29号楼
			geolocationMark: null, // 自定义 定位图标
			cateIdList: null, // 类型id数组
			token: this.$store.getters.token,
			shareConfig: null, // 分享的相关配置
			tradesmanId: null, // 匠人id
        };
    },
    components: {
		PageSearch,
    },
    created: function () {
		if(localStorage.getItem("tradesmanId")){
			this.tradesmanId = localStorage.getItem("tradesmanId");
			// console.log("匠人id",this.tradesmanId)
		};
		if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '项目'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                // 获取项目分类 非遗、乡间等大类
				this.getItemType()
				// 项目分类列表 音乐、文学、曲艺等小类
				this.getCateList()
				// this.dingweiMap()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            // 获取项目分类 非遗、乡间等大类
			this.getItemType()
			// 项目分类列表 音乐、文学、曲艺等小类
			this.getCateList()
			// this.dingweiMap()
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
			this.getShareData();
        }        
    },
    mounted() {
		let that = this;
		// 定位
		this.dingweiMap()
    },
    methods: {
        // 项目分类
        getItemType() {
            this.$api.map.itemTypenew().then(res => {
                if (res.code == 200) {
                    console.log("项目分类");
                    // console.log(res)
                    var arr = res.result;
                    arr.map(function (item) {
						item.is_selected = true
                    });
					this.typeList = arr;
					this.type_id = [];
					for(var i in arr){
						this.type_id.push(arr[i].id)
					}
                    console.log(this.typeList);
                }
            });
        },
        // 周边定位点
        getData(arr,lng,lat,init) {
			var that = this
			if(!that.tradesmanId){
				var params = {
					token: that.token,
					lng: lng,
					lat: lat,
					type_id: arr
				};
				// 当这几个项目都不点选时,不请求数据
				if (arr.length == 0) {
					// that.markerGroups = []
					// return
					params.type_id = [9,9,9,9,9]
				}
				if(that.cateIdList) {
					params.cateIdList = that.cateIdList
				}
				console.log(params);
				// console.log('that.lng')
				// console.log(that.lng)
				that.$api.map.searchItem(params).then(res=>{
					if(res.code == 200){
						console.log('res')
						var markers = res.result
						for(var i in markers){
							var arr = []
							arr.push(markers[i].lng)
							arr.push(markers[i].lat)
							markers[i].position = arr
						}
						that.markerGroups = markers
						that.renderMarkers(that.markerGroups,init)
					}
				})
			}else{
				// console.log("商家关联的项目",this.tradesmanId);
				// 商家关联的项目
				let params = {
					tradesman_id: this.tradesmanId
				};
				that.$api.tradesman.item(params).then(res=>{
					if(res.code == 200){
						console.log('res')
						var markers = res.result
						for(var i in markers){
							var arr = []
							arr.push(markers[i].lng)
							arr.push(markers[i].lat)
							markers[i].position = arr
						}
						that.markerGroups = markers
						that.renderMarkers(that.markerGroups,init)
					}
				})
			}
        },
        // 打开全国非遗
        goQuanguo(type) {
			console.log('type',type)
			if(type == 0){
				this.$router.push({
					path: "/quanguo/index"
				});
			}else if(type == 1){
				this.$router.push({
					path: "/quanqiu/index"
				});
			}
           
		},
        // 各项目是否选中
        selectedFun(item, index) {
            item.is_selected = !item.is_selected;
            console.log("this.typeList");
            console.log(this.typeList);
            var arr = new Array();
            for (var i in this.typeList) {
                if (this.typeList[i].is_selected) {
                    arr.push(this.typeList[i].id);
                }
            }
            this.type_id = arr;
            console.log("index", index);
            // console.log(this.$refs.item[index])
            if (!item.is_selected && index == 0) {
                $(this.$refs.item[index]).addClass("unItem0");
            } else if (item.is_selected && index == 0) {
                $(this.$refs.item[index]).removeClass("unItem0");
            }
            if (!item.is_selected && index == 1) {
                $(this.$refs.item[index]).addClass("unItem1");
            } else if (item.is_selected && index == 1) {
                $(this.$refs.item[index]).removeClass("unItem1");
            }
            if (!item.is_selected && index == 2) {
                $(this.$refs.item[index]).addClass("unItem2");
            } else if (item.is_selected && index == 2) {
                $(this.$refs.item[index]).removeClass("unItem2");
            }
            if (!item.is_selected && index == 3) {
                $(this.$refs.item[index]).addClass("unItem3");
            } else if (item.is_selected && index == 3) {
                $(this.$refs.item[index]).removeClass("unItem3");
            }
            if (!item.is_selected && index == 4) {
                $(this.$refs.item[index]).addClass("unItem4");
            } else if (item.is_selected && index == 4) {
                $(this.$refs.item[index]).removeClass("unItem4");
			}
            this.getData(arr,this.lng,this.lat,1);
        },
        
        // 渲染地图覆盖物
        renderMarkers: function (markerGroups,init) {
			var that = this;
			// 清除地图上的所有覆盖物，再添加新数据
			that.map.clearMap(); 
            console.log("markerGroups");
			console.log(markerGroups,init);
            // 添加覆盖物 创建覆盖物群组
            var markers = [];
            for (var i in markerGroups) {
				// 创建点实例
				var markItem = markerGroups[i]
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(
                        parseFloat(markerGroups[i].position[0]),
                        parseFloat(markerGroups[i].position[1])
					),
					icon: that.$publicData.withHttpStart(markerGroups[i].icon)  ? markerGroups[i].icon : that.imageUrl+markerGroups[i].icon ,
                    extData: { // 自定义属性
                        id: markerGroups[i].id,
						level: markerGroups[i].item.level?markerGroups[i].item.level.title:'',
						title: markerGroups[i].title,
						content: markerGroups[i].describe ? markerGroups[i].describe : '',
						lng: parseFloat(markerGroups[i].position[0]),
						lat: parseFloat(markerGroups[i].position[1]),
						auth_status: markerGroups[i].auth_status == 1 ? '地址已认证': '地址未认证'
                    },
                    map: that.map
				});
                markers.push(marker);
            }
            // 覆盖物组
			var overlayGroups = new AMap.OverlayGroup(markers);
			// 覆盖物组加事件
			overlayGroups.on('click',function (e){
				console.log(e.target.getExtData())
				that.infoTitle = e.target.getExtData().title
				that.infoId = e.target.getExtData().id
				that.infoLng = e.target.getExtData().lng
				that.infoLat = e.target.getExtData().lat
				var content = e.target.getExtData().content
				var auth_status = e.target.getExtData().auth_status
				var level = e.target.getExtData().level
				var infoWindow = new AMap.InfoWindow({
					isCustom: true,  //使用自定义窗体
					content: that.createInfoWindow(level ,that.infoTitle, content,that.infoId,that.infoLng,that.infoLat,auth_status),
					anchor: 'bottom-center', // 默认值 top-center
					// offset: new AMap.Pixel(16, -45),
					// position: new AMap.LngLat(
					// 			e.target.getPosition().lng,
					// 			e.target.getPosition().lat
					// 		),
				});
				infoWindow.open(that.map, e.target.getPosition()); 
				var lat = document.createAttribute('data-lat');
				var lng = document.createAttribute('data-lng');
				lat.nodeValue = that.infoLat;
				lng.nodeValue = that.infoLng;
				setTimeout(function() {
					console.log(document.querySelector('.info_hongbao'))
					document.querySelector('.info_hongbao').setAttributeNode(lat);
					document.querySelector('.info_hongbao').setAttributeNode(lng);
				},100)
			})
			console.log('调了吗')
			console.log('坐标:',localStorage.getItem('lng'), localStorage.getItem('lat'))
			// 添加中心点
			that.centerMarker = new AMap.Marker({
				map: that.map,
				icon: that.publicPath+'statics/images/centerMark.png', // centerMark
				position: new AMap.LngLat(that.lng, that.lat),
				// zIndex: 10
			})
			// 添加定位点
			that.locationMarker = new AMap.Marker({
				map: that.map,
				icon: that.publicPath+'statics/images/locationMark.png', // locationMark
				position: new AMap.LngLat(localStorage.getItem('lng') == null ? that.$publicData.locationDefault.lng : localStorage.getItem('lng'), localStorage.getItem('lat') == null ? that.$publicData.locationDefault.lat : localStorage.getItem('lat')),
				// zIndex: 10
			})
			if(init){
				that.map.setFitView() // 根据地图上添加的覆盖物分布情况，自动缩放地图到合适的视野级别，默认是当前地图上添加的覆盖物	
			}
			that.map.setCenter([that.lng,that.lat]);
        },
		// 点击左侧图标
		clicksearchleft(){
			// 没有左侧图标
			return;
		},
		// 触发focus
		showFullScreenSearchPage(){
			this.$router.push({
				path: '/search/item',
				query: {
					routeName: 'map',
					type_id: this.type_id[0]
				}
			})
		},
		// 点击右侧图标
		clicksearchright(){
			// 打开筛选弹层
			this.search_status = !this.search_status;
		},
		// 确认选中地区
        confrimArea(data){
            this.areaPicker = false;
			var arr = []
			var str = ''
			var adress = ''
			// for(var i in data){
			// 	arr.push(data[i].name)
			// }
			// this.area_name = arr
			for(var i = 0; i< data.length ; i++){
				if(data[i] && data[i].name){
					arr.push(data[i].name)
				}
			}
			for(var j = 0; j<arr.length; j++){
				if(j == 0){
					str = arr[j]
					adress = arr[j]
				}else if(j == 1){
					str = str+'-'+arr[j]
					adress += arr[j]
				}else{
					str = str+'-'+arr[j]
					adress += arr[j]
				}
			}
			this.area_name = arr
			this.selectArea = str
			this.adress = adress
			// console.log('确认adress')
			// console.log(this.adress)
			this.getSearchLocation(this.adress)
		},
		// 获取项目分类列表
		getCateList(){
			var params = {
				token: this.token,
				page: 1,
				size: 999
			}
			this.$api.map.cateList(params).then(res=>{
				if(res.code == 200){
					console.log('获取项目分类列表')
					console.log(res)
					this.cateList = res.result.list
					for(var i in this.cateList){
						this.cateList[i].status = 0
					}
				}
			})
		},
		// 点击各个项目类型 判断它是否为选中状态
		selectCate(item){
			for(var i in this.cateList){
				if(this.cateList[i].id == item.id){
					if(item.status == 0){
						$('.search_item[data-id='+item.id+ ']').addClass('active')
						item.status = 1
					}else{
						$('.search_item[data-id='+item.id+ ']').removeClass('active')
						item.status = 0
					}
				}
			}
			console.log(item)
		},
		// 重置
		reset(){
			// 将项目类型重置
			for(var i in this.cateList){
				this.cateList[i].status = 0
			}
			$('.search_item').removeClass('active')
			// 将省市区重置, 定位成功时取当前定位地址,定位失败取默认定位 天津
			if(localStorage.getItem('positionAdress')){
				this.selectArea = this.myAdress
				this.area_name = this.myAdressArr
				this.getSearchLocation(this.myAdressText)
			}else{
				this.selectArea = '天津'
				this.area_name = null
			}
		},
		// 确定
		submit(){
			console.log('确定')
			console.log(this.area_name)
			console.log(this.cateList)
			var cateIdList = []
			for(var i in this.cateList){
				if(this.cateList[i].status == 1){
					cateIdList.push(this.cateList[i].id)
				}
			}
			this.cateIdList = cateIdList
			var params = {
				token: this.token,
				lng: this.lng,
				lat: this.lat
			}
			if(this.type_id.length != 0){
				params.type_id = this.type_id
			}else{
				params.type_id = [9,9,9,9,9]
			}
			console.log('type_id',this.type_id)
			// if(this.area_name){
			// 	params.area_name = this.area_name
			// 	params.area_level = (this.area_name).length
			// }
			if(cateIdList.length>0){
				params.cateIdList = cateIdList
			}
			console.log('params')
			console.log(params)
			// 关闭筛选弹层
			this.search_status = false
			this.$api.map.searchItem(params).then(res=>{
				if(res.code == 200){
					console.log('res')
					var markers = res.result
					for(var i in markers){
						var arr = []
						arr.push(markers[i].lng)
						arr.push(markers[i].lat)
						markers[i].position = arr
					}
					// this.markerGroups = arr
					console.log('筛选后markers')
					console.log(markers)
					this.markerGroups = markers
					// 获取筛选城市的坐标值 同时改变地图中心坐标点
					console.log('this.adress',this.adress)
					// this.getSearchLocation(this.adress)
					this.renderMarkers(this.markerGroups,0)
				}
			})
		},
		// 定位
		dingweiMap(){
			console.log('dingweiMap==')
			var that = this;
			if(that.map){
				that.map.destroy();
			};
			that.map = new AMap.Map("container", {
				zoom: 12,
				resizeEnable: true, // 是否监控地图容器尺寸变化
			});
			// 加载插件 定位 工具条
            AMap.plugin(["AMap.Geolocation","AMap.ToolBar"], function () {
				// 定位  Geolocation 手机端优先使用浏览器定位，失败后使用IP定位
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：5s
                    buttonPosition: "LB", //定位按钮的停靠位置
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
					zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
					buttonDom: document.getElementById('mapBtn'), // 自定义定位按钮 对应button
					panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
					showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
					// markerOptions: { // 定位点Marker的配置，不设置该属性则使用默认Marker样式
					// 	icon: that.publicPath+'statics/images/locationMark.png',
					// 	map: that.map,
					// 	position: new AMap.LngLat(that.lng,that.lat)
					// },
					showCircle: false, // 定位成功并且有精度信息时，是否用一个圆圈circle表示精度范围
				});
				//加载工具条
				var tool = new AMap.ToolBar({
					position: 'LB',
					ruler: false,
					liteStyle: true,
				});
				that.map.addControl(tool);
                // console.log("geolocation");
				// console.log(geolocation);
				// console.log('addControl')
				// console.log(map.addControl(geolocation));
				that.map.addControl(geolocation)
                geolocation.getCurrentPosition(function (status, result) {
                    // console.log('this')
                    // console.log(that)
                    if (status == "complete") {
						that.onComplete(result);
                    } else {
                        that.onError(result);
                    }
				});
				// 拖拽
				that.dragMap()
			});
		},
		// 定位成功
        onComplete(data) {
			var that = this
            console.log("定位成功");
            console.log(data);
            that.lng = data.position.lng
			that.lat = data.position.lat
			that.myAdressTextDetail = data.formattedAddress // 详细地址
			localStorage.setItem('lng',data.position.lng)
			localStorage.setItem('lat',data.position.lat)
			that.positionAdress.province = data.addressComponent.province
			that.positionAdress.city = data.addressComponent.city
			that.positionAdress.district = data.addressComponent.district
			var positionAdress = JSON.stringify(that.positionAdress);
			localStorage.setItem('positionAdress',positionAdress)
			// 判断选择地区，如果未选择地区用当前定位地址
			if(localStorage.getItem('positionAdress')){
				var positionAdress = JSON.parse(localStorage.getItem('positionAdress'))
				var str = positionAdress.province + '-' + positionAdress.city + '-' + positionAdress.district
				that.selectArea = str
				var arr = []
				arr.push(positionAdress.province,positionAdress.city,positionAdress.district)
				that.area_name = arr
				var adressText = positionAdress.province+ positionAdress.city + positionAdress.district
				that.adress = adressText
				that.myAdress = str
				that.myAdressArr = arr
				that.myAdressText = adressText
			}
			that.getData(that.type_id,that.lng,that.lat,1)
        },
        // 定位失败
        onError(data) {
            console.log("定位失败");
			console.log(data);
			var that = this
			that.lng = that.$publicData.locationDefault.lng
			that.lat = that.$publicData.locationDefault.lat
			localStorage.setItem('lngDefault',that.$publicData.locationDefault.lng)
			localStorage.setItem('latDefault',that.$publicData.locationDefault.lat)
			that.selectArea = '天津'
			that.myAdressText = '天津'
			that.getData(that.type_id,that.lng,that.lat,1)
		},
		//  用于你解析地址获取坐标点
		getSearchLocation(adress){
			console.log('adress',adress)
			var that = this;
			console.log("that");
			console.log(that);
			// var map = new AMap.Map("container", {
			// 	zoom: 12,
			// 	center: [that.lng,that.lat]
			// 	// center: [115.670113,37.726951]
			// });
			// console.log("map");
			// console.log(that.map);
			// 逆地址解析
			AMap.plugin("AMap.Geocoder", function(){
				var geocoder = new AMap.Geocoder({
					// 默认全国
				});
				console.log('geocoder')
				console.log(geocoder)
				geocoder.getLocation(adress,function(status,result){
					console.log('status')
					console.log(status)
					console.log('result')
					console.log(result)
					if (status === 'complete'&& result.geocodes.length){
						that.lng = result.geocodes[0].location.lng
						that.lat = result.geocodes[0].location.lat
						console.log('lngNew',that.lng)
						console.log('latNew',that.lat)
						// that.map.setCenter([that.lng,that.lng])
					}
				})
			})		
		},
		// 回到定位点
		clickButtonDom(){
			console.log('回到定位点')
			var that = this
			// console.log('clickButtonDom')
			// 把地址置回，拿到位置的坐标点，并清空筛选条件
			that.selectArea = that.myAdress
			that.area_name = that.myAdressArr
			console.log('that.myAdressText',that.myAdressText)
			var dizhi = that.myAdressTextDetail ? that.myAdressTextDetail : that.myAdressText
			that.getSearchLocation(dizhi)
			that.lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : localStorage.getItem('lngDefault')
			that.lat = localStorage.getItem('lat') ? localStorage.getItem('lat') : localStorage.getItem('latDefault')
			console.log('详细地址',dizhi)
			for(var i in that.cateList){
				that.cateList[i].status = 0
			}
			that.map.panTo([that.lng,that.lat]) // 地图中心点平移至指定点位置
			// that.map.setCenter([that.lng,that.lat])
			// 请求 当前位置的数据
			that.getData(that.type_id,that.lng,that.lat,0)
		},
		// 构建自定义信息窗体
		createInfoWindow(level,title,content,id,lng,lat,createInfoWindow) {
			var that = this
			// content 最多显示五行半,约130个字，多于130个字加...
			var newContent = null
			if(content.length > 130){
				newContent = content.slice(0,130)+'...'
			}else{
				newContent = content
			}
			// 定义窗体内容
			var info = document.createElement("div");
			info.className = "custom_info";
			// 定义顶部标题
			var top = document.createElement("div");
			top.className = "info_top";
			var back = document.createElement("div");
			back.className = "info_back";
			
			var levelD = document.createElement("span");
			levelD.className = "info_level"
			levelD.innerHTML = level
			
			var titleD = document.createElement("div");
			titleD.className = "info_title"
			titleD.innerHTML = "<span class='info_level'>「"+level+"」</span>"+title
			var closeX = document.createElement("img");
			closeX.className = 'info_close'
			closeX.src = that.publicPath + "statics/images/close_item.png";
			closeX.onclick = that.closeInfoWindow;
			top.appendChild(back);
			
			back.appendChild(titleD);
			// titleD.appendChild(levelD);
			// var children = titleD.querySelectorAll('div')
			// console.log('children:',children)
			// titleD.insertBefore(levelD,children[0])
			top.appendChild(closeX);
			info.appendChild(top);
			// 定义中部内容
			var middle = document.createElement("div");
			middle.className ='middle_wrap';
			var infoContent = document.createElement("span");
			infoContent.className = "info_middle";
			infoContent.innerHTML = newContent;
			var infoDetail = document.createElement("span")
			infoDetail.innerHTML = '【查看详情】';
			infoDetail.className = 'info_detail';
			infoDetail.onclick = that.goItemInfo;
			middle.appendChild(infoContent);
			middle.appendChild(infoDetail);
			info.appendChild(middle);
			// // 定义底部内容
			var bottom = document.createElement("div");
			bottom.className = "info_bottom";
			// 定义 底部左侧
			// var bottomLeft = document.createElement("div");
			// bottomLeft.className = 'bottomLeft';
			var infoRenzheng = document.createElement("div");
			infoRenzheng.innerHTML = createInfoWindow
			infoRenzheng.className = 'infoRenzheng'
			// bottomLeft.appendChild(infoDetail)
			bottom.appendChild(infoRenzheng)

			// 定义底部 右侧
			var bottomRight = document.createElement("div");
			bottomRight.className = "bottomRight";
			var hongbao = document.createElement("div")
			hongbao.className = "info_hongbao";
			hongbao.innerHTML = '领红包'
			hongbao.id = id;
			hongbao.onclick = that.getHongBao
			var zheli = document.createElement("div")
			zheli.className = "info_zheli";
			zheli.innerHTML = '去这里'
			zheli.onclick = that.goSomeWhere
			bottomRight.appendChild(hongbao);
			bottomRight.appendChild(zheli);
			// bottom.appendChild(bottomLeft)
			bottom.appendChild(bottomRight)
			info.appendChild(bottom);

			// 红包列表
			// var redpacket = document.createElement("div");
			// redpacket.className = "redpacket_wrap";
			// // redpacket.innerHTML = '<h3>领红包</h3>'
			// that.$api.map.getLocationNotes({
			// 	token: that.$store.getters.token,
			// 	location_id:id
			// }).then(res => {
			// 	console.log(res)
			// 	var datas = res.result;
			// 	if ( res.code == 200 ) {
			// 		for(var i = 1; i <= 4;i ++) {
			// 			console.log(datas['note_'+i]);
			// 			var hasPacket = false;
			// 			if ( datas['note_'+i] != undefined && datas['note_'+i] == i ) {
			// 				hasPacket = true;
			// 			}
			// 			var packet = document.createElement("img");
			// 			packet.className = hasPacket ? 'packet' : 'packet gray';
			// 			packet.src = that.publicPath + "statics/images/note"+ i +".png";
			// 			packet.onclick = that.lingNote;
			// 			redpacket.appendChild(packet);
			// 			info.appendChild(redpacket);
			// 		}
			// 	}				
			// })
			
			return info
		},
		// 关闭信息窗体
		closeInfoWindow(){
			this.showInfo = false;
			this.map.clearInfoWindow()
		},
		// 查看项目详情
        goItemInfo: function () {
			// console.log('去详情')
			// console.log(this.infoId)
            this.$router.push({
                path: "/item/detail",
                query: {
                    id: this.infoId
                }
            });
        },
		// 去这里
		goSomeWhere() {
			console.log('去这里')
			// console.log(this.infoTitle)
			// console.log(this.infoLng)
			// console.log(this.infoLat)
            // console.log(window)
            window.location.href = '//uri.amap.com/marker?position=' + this.infoLng + ',' + this.infoLat + '&name=' + this.infoTitle
		},
		// 获取该点红包
		getHongBao(e){
			// console.log('领红包',e.target.id,e.target.dataset.lat,e.target.dataset.lng)
			// document.querySelector('.redpacket_wrap').style.display="block";
			var that = this;
			var redpacket = document.querySelector('.redpacket_wrap');
			if ( redpacket != null ) {
				redpacket.remove();
			}
			// 红包列表
			var redpacket = document.createElement("div");
			redpacket.className = "redpacket_wrap";
			// redpacket.innerHTML = '<h3>领红包</h3>'
			that.$api.map.getLocationNotes({
				token: that.$store.getters.token,
				location_id:e.target.id
			}).then(res => {
				console.log(res)
				var datas = res.result;
				if ( res.code == 200 ) {
					for(var i = 1; i <= 4;i ++) {
						console.log(datas['note_'+i]);
						var hasPacket = false;
						if ( datas['note_'+i] != undefined && datas['note_'+i] == i ) {
							hasPacket = true;
						}
						var packet = document.createElement("img");
						packet.className = hasPacket ? 'packet' : 'packet gray';
						packet.src = that.publicPath + "statics/images/note"+ i +".png";
						packet.onclick = that.lingNote;
						packet.id= 'note' + i;
						var isgray = document.createAttribute('data-gray');
						var locationId = document.createAttribute('data-locationid');
						// var lat = this.lat;	// document.createAttribute('data-lat');
						// var lng = this.lng; 	// document.createAttribute('data-lng');

						isgray.nodeValue = hasPacket;
						locationId.nodeValue = e.target.id;
						// lat.nodeValue = e.target.dataset.lat;
						// lng.nodeValue = e.target.dataset.lng;

						redpacket.appendChild(packet);
						document.querySelector('.custom_info').appendChild(redpacket);
						document.querySelector('#note' + i).setAttributeNode(isgray);
						document.querySelector('#note' + i).setAttributeNode(locationId);
						// document.querySelector('#note' + i).setAttributeNode(lat);
						// document.querySelector('#note' + i).setAttributeNode(lng);
					}
				}
				
			})
		},
		// 领取红包
		lingNote(e) {
			var that = this;
			console.log(e.target.dataset.gray)
			var isgray = e.target.dataset.gray;
			if ( isgray != 'true' ) {
				that.$toast('此店该红包已领完');
				return;
			}

			that.$api.map.lingNote({
				token: that.$store.getters.token,
				location_id: e.target.dataset.locationid,
				lat: localStorage.getItem('lat') ? localStorage.getItem('lat') : that.$publicData.locationDefault.lat,
				lng: localStorage.getItem('lng') ? localStorage.getItem('lng') : that.$publicData.locationDefault.lng
			}).then(res => {
				that.$toast(res.message);
				// if ( res.code == 200 ) {
					document.querySelector('.redpacket_wrap').remove();
				// }
			})

			console.log('123213')
		},
		// 地图拖拽
		dragMap(){
			var that = this
			that.map.on('dragend', function (e) {
				// 一些操作
				console.log('拖拽')
				console.log(that.map.getCenter())
				// console.log(that.map)
				that.lng = that.map.getCenter().lng;
				that.lat = that.map.getCenter().lat;
				that.map.panTo([that.lng,that.lat]) // 地图中心点平移至指定点位置
				that.getData(that.type_id,that.lng,that.lat,0)
			});
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: '非遗地图', // 分享标题
					desc: '从非遗文化的留存，探索这个地区的历史源流和文化发展轨迹……\n非遗在身边，让我们一起探寻非物质文化遗产地图！', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.shareImgPath + 'ditu.jpg', // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
	destroyed: function(){
		localStorage.removeItem("tradesmanId");
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#container {
    height: 100vh;
}
/deep/.amap-icon img{
	/* width: 0.493rem; */
	width: .8rem;
	height: auto;
}
/deep/.van-cell .van-field__control{
	color: #212121;
}
</style>
